import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { systemMockupUrl } from '../data/content';
import { CtaButton } from './CtaButton';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-navy-deep" data-id="element-95" data-mp="9l37jlcn0s87">
      <div aria-hidden="true" className="absolute inset-0 opacity-[0.07]" style={{
      backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)',
      backgroundSize: '56px 56px'
    }} data-id="element-96" data-mp="4n1lcrjx0csi" />
      <div className="relative mx-auto max-w-5xl px-6 py-16 lg:py-24" style={{
      paddingTop: "11px"
    }} data-id="element-97" data-mp="sa02lrfuzorh">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="text-center" data-id="element-98" data-mp="nboov5mg0u3z">
          <p className="mb-6 inline-block rounded-full border border-white/15 bg-white/5 px-4 py-2 text-[11px] font-bold uppercase tracking-[0.16em] text-trust" data-id="element-99" data-mp="381nu37c3sp2w">
            The #1 Overlooked Health Risk In Every Home
          </p>
          <h1 className="mx-auto max-w-4xl text-4xl font-extrabold leading-[1.08] tracking-tight text-slate-50 sm:text-5xl" data-id="element-100" data-mp="3o5j39ad4ljlt">
            Your Medicine Cabinet Feels Safe.{' '}
            <span className="text-trust" data-id="element-101" data-mp="3e7uw1kyc2jmr">It Probably Isn’t.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-300" data-id="element-102" data-mp="30gzw4y5tbcvb">
            Expired medications, incorrect storage, and dangerous supplement combinations are
            silently putting your family at risk right now — and most households have no way to know.
            Until today.
          </p>
        </motion.div>

        <motion.img initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.15,
        ease: 'easeOut'
      }} src={systemMockupUrl} alt="The Pharma-Masterclave — all 6 complete guides and 3 exclusive action tools shown together" className="mx-auto mt-12 w-full rounded-2xl border border-white/10 bg-white shadow-2xl" loading="eager" data-id="element-103" data-mp="2vgtx2wx7qo37" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3,
        ease: 'easeOut'
      }} className="mt-12 flex flex-col items-center text-center" data-id="element-104" data-mp="ic86patlvyvq">
          <div className="w-full max-w-xl" data-id="element-105" data-mp="1azul7e4dgnxd">
            <CtaButton href="#checkout" className="w-full" data-id="element-106" data-mp="1ayt710s27lbf">
              ✅ Protect my family now — $27
            </CtaButton>
          </div>

          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-slate-300" data-id="element-107" data-mp="111ycesywq52f">
            <li className="flex items-center gap-2" data-id="element-108" data-mp="x032j02wujd1">
              <ShieldCheckIcon className="h-4 w-4 text-trust" aria-hidden="true" data-id="element-109" data-mp="3lsysay1o8kij" />
              7-Day Money-Back Guarantee
            </li>
            <li className="flex items-center gap-2" data-id="element-110" data-mp="3hqaian1817jz">
              <span className="flex items-center gap-0.5 text-trust" aria-hidden="true" data-id="element-111" data-mp="3htpwzoqzgekv">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-4 w-4 fill-current" data-id="element-112" data-mp="21amtp33s7gj6" />)}
              </span>
              <span className="font-semibold text-slate-50" data-id="element-113" data-mp="26a9afmitjewq">4.9/5 Verified Reviews</span>
            </li>
            <li className="flex items-center gap-2" data-id="element-114" data-mp="2b0fz1mdbyzez">
              <ZapIcon className="h-4 w-4 text-trust" aria-hidden="true" data-id="element-115" data-mp="2b20s17jzyaaq" />
              Instant Digital Delivery
            </li>
            <li className="flex items-center gap-2" data-id="element-116" data-mp="2kyvlvd5brmio">
              <CheckCircleIcon className="h-4 w-4 text-trust" aria-hidden="true" data-id="element-117" data-mp="2kxc6rpvenhih" />
              9 PDF files, yours forever
            </li>
          </ul>
        </motion.div>
      </div>
    </header>;
}